export type AccountStatus = {
  AccountRequested: number;
  AccountActivated: number;
  AccountDeactivated: number;
  AccountUpdated: number;
};
